module.exports = __webpack_public_path__ + "img/arrow-down-right.fb0fb43a.svg";